/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetawsreportAWSMFAReport
 */
export interface JumboGetawsreportAWSMFAReport {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetawsreportAWSMFAReport
     */
    isEnforced?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JumboGetawsreportAWSMFAReport
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the JumboGetawsreportAWSMFAReport interface.
 */
export function instanceOfJumboGetawsreportAWSMFAReport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetawsreportAWSMFAReportFromJSON(json: any): JumboGetawsreportAWSMFAReport {
    return JumboGetawsreportAWSMFAReportFromJSONTyped(json, false);
}

export function JumboGetawsreportAWSMFAReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetawsreportAWSMFAReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isEnforced': !exists(json, 'isEnforced') ? undefined : json['isEnforced'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}

export function JumboGetawsreportAWSMFAReportToJSON(value?: JumboGetawsreportAWSMFAReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isEnforced': value.isEnforced,
        'updatedAt': value.updatedAt,
    };
}

